document.addEventListener("DOMContentLoaded", function () {
  let slides = document.querySelectorAll(".slide");
  let index = 0;
  let slideDuration = 4000; // 4 seconds per slide
  let fadeDuration = 1500;  // 1.5 seconds fade effect

  // Initialize slides
  slides.forEach((slide, i) => {
    slide.style.opacity = i === 0 ? "1" : "0"; // Show first slide
    slide.style.transition = `opacity ${fadeDuration / 1000}s ease-in-out`;
    slide.style.position = "absolute";
    slide.style.width = "100%";
    slide.style.height = "100%";
  });

  function showSlides() {
    let currentSlide = slides[index];
    let nextIndex = (index + 1) % slides.length;
    let nextSlide = slides[nextIndex];

    // Fade out current slide
    currentSlide.style.opacity = "0";
    // Fade in next slide
    nextSlide.style.opacity = "1";

    // Update index
    index = nextIndex;

    setTimeout(showSlides, slideDuration);
  }

  setTimeout(showSlides, slideDuration); // Start the slideshow after initial delay
});
